/* ── Split-pane layout ── */

.documentView {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-template-rows: auto 1fr;
    height: 100%;
    overflow: hidden;
}

.documentViewHeader {
    grid-column: 1 / 3;
    grid-row: 1;
    padding: 1.5rem;
    border-bottom: 1px solid var(--mantine-color-gray-3);
}

.documentViewHeader h1 {
    font-weight: bold;
    line-height: 1.875rem;
    margin: 0;
}

.documentForm {
    grid-column: 1;
    grid-row: 2;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    padding: 0 1.5rem;
    border-right: 1px solid var(--mantine-color-gray-2);
}

.documentFormScroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

.documentFormTop,
.documentFormBottom {
    flex-shrink: 0;
    background: var(--mantine-color-white);
    padding: var(--mantine-spacing-md) 0;
}

.documentFormTop {
    display: flex;
    justify-content: flex-end;
}

.documentPreview {
    grid-column: 2;
    grid-row: 2;
    overflow: auto;
    height: 100%;
    padding: 1rem;
}

/* ── Global styles for dokumentgenerator package ── */
/* These target class names generated internally by the package.
   Nested inside .documentView so they only apply within the document context. */

.documentView :global(.xvar-form) {
    position: relative;
}

.documentView ul,
.documentView ol {
    margin: 1rem 0;
}

.documentView h1,
.documentView h2,
.documentView h3,
.documentView h4,
.documentView h5 {
    font-family: var(--mantine-font-family);
    font-weight: bold;
    line-height: 1.875rem;
    margin-right: 1rem;
    margin-block: var(--mantine-spacing-md);
}

.documentView h1 {
    font-size: 1.5rem;
}

.documentView h2 {
    font-size: var(--mantine-font-size-xl);
}

.documentView h3 {
    font-size: var(--mantine-font-size-lg);
}

.documentView h4,
.documentView h5 {
    font-size: var(--mantine-font-size-md);
}

.documentView :is(ol:not([type]), ol:not([style*="list-style-type"])) {
    counter-reset: docgen-counter;
}

.documentView :global(.desccontainer) {
    border-bottom: 1px solid var(--mantine-color-gray-2);
    margin-bottom: 1rem;
    padding-bottom: 1rem;
}

.documentView :global(.dib-x-comment-tag) {
    font-style: normal;
    font-family: var(--mantine-font-family);
    font-weight: bold;
    line-height: 1.875rem;
    margin-right: 1rem;
    font-size: var(--mantine-font-size-xl);
}

/* ── Variable views ── */

.documentView :global(.xvar-view) {
    color: hsl(197, 97%, 12%);
    cursor: pointer;
    margin: 0 2px;
    font-weight: bold;
    border-bottom: 2px solid hsl(197, 97%, 12%);
}

.documentView :global(.xvar-view.hasValue) {
    color: #333;
    font-weight: inherit;
    border-bottom: 2px solid hsl(197, 97%, 12%);
}

.documentView :global(.xvar-view.focused) {
    color: hsla(20, 80%, 58%, 1);
    border-bottom: 2px solid hsla(20, 80%, 58%, 1);
}

/* ── Sections ── */

.documentView section[data-autocount] {
    margin: 3rem 0;
}

/* ── Alternatives v1 ── */

.documentView :global(.x-alternatives) > header {
    font-style: italic;
}

.documentView :global(.x-alternatives) > ol {
    padding: 0;
    list-style: none;
}

.documentView :global(.x-alternatives-inline) {
    display: inline;
}

.documentView :global(.x-alternatives-inline) > ol {
    display: inline;
    padding: 0 0.5rem;
}

.documentView :global(.x-alternatives-inline) > ol > li {
    display: inline;
}

.documentView :global(.x-alternatives) header {
    padding: 0 0.5rem;
}

.documentView :global(.x-alternatives) :global(.x-alternative) {
    padding: 0.5rem;
}

.documentView :global(.x-alternative__inner) {
    display: flex;
}

.documentView :global(.x-alternative) {
    margin: 1rem 0 1rem -1rem;
}

.documentView :global(.x-alternative) :global(.x-alternative__inner) {
    flex: 1 0 100%;
}

.documentView :global(.x-alternatives-inline) :global(.x-alternative) {
    margin: 0 0;
}

.documentView :global(.x-alternatives-inline) :global(.x-alternative__inner) {
    align-items: center;
    display: inline;
}

.documentView
    :global(.x-alternatives-inline)
    :global(.x-alternative__inner)
    > input[type="radio"] {
    display: inline;
    margin: 0 0.5rem;
}

.documentView
    :global(.x-alternatives-inline)
    :global(.x-alternative__inner)
    > label {
    display: inline;
}

.documentView
    :global(.x-alternatives-inline)
    :global(.x-alternative__inner)
    > :global(.x-alternative__children) {
    border: none;
    display: inline;
}

.documentView :global(.x-alternative__children) {
    border-radius: 0.5rem;
    border: 1px solid var(--mantine-color-gray-2);
    opacity: 0.5;
    padding: 1rem;
    width: 100%;
    overflow: auto;
}

.documentView :global(.x-alternative__children) > ol {
    margin-left: 1rem;
    padding-left: 0;
}

.documentView
    :global(.x-alternatives-inline)
    :global(.x-alternative__children) {
    padding: 0 0.5rem;
}

.documentView
    :global(.x-alternative--selected)
    > :global(.x-alternative__inner)
    > :global(.x-alternative__children) {
    background-color: hsl(195, 20%, 96%);
    border: 1px solid var(--mantine-color-gray-2);
    opacity: 1;
}

.documentView input[type="radio"] {
    margin: 1.25rem 1rem;
}

/* ── Section autocount ── */

/*
Vanlige section.level[data-autocount="true"] etter rtk transform:
section.level[data-autocount="true"]
h1 - h6
.dib-x-section__children
    section.level[data-autocount="true"]
    section.level[data-autocount="true"]

Optional section[data-autocount="true"] fra docgen:
x-section-optional
input
label
.x-section-optional__children
    h1-6 (for x-section-optional)
    .dib-x-section__children
*/

.documentView
    :global(section.x-section-optional--checked[data-autocount="true"]),
.documentView :global(section.level[data-autocount="true"]) {
    counter-increment: dibcounter;
}

.documentView
    :global(section.x-section-optional[data-autocount="true"])
    :global(.dib-x-section__children),
.documentView
    :global(section.level[data-autocount="true"])
    :global(.dib-x-section__children) {
    counter-reset: dibcounter;
}

.documentView
    :global(section.level[data-autocount="true"])
    > :global(h1:first-of-type::before),
.documentView
    :global(section.level[data-autocount="true"])
    > :global(h2:first-of-type::before),
.documentView
    :global(section.level[data-autocount="true"])
    > :global(h3:first-of-type::before),
.documentView
    :global(section.level[data-autocount="true"])
    > :global(h4:first-of-type::before),
.documentView
    :global(section.level[data-autocount="true"])
    > :global(h5:first-of-type::before),
.documentView
    :global(section.level[data-autocount="true"])
    > :global(h6:first-of-type::before),
.documentView
    :global(.x-section-optional--checked[data-autocount="true"])
    > :global(.x-section-optional__children)
    > :global(h1:first-of-type::before),
.documentView
    :global(.x-section-optional--checked[data-autocount="true"])
    > :global(.x-section-optional__children)
    > :global(h2:first-of-type::before),
.documentView
    :global(.x-section-optional--checked[data-autocount="true"])
    > :global(.x-section-optional__children)
    > :global(h3:first-of-type::before),
.documentView
    :global(.x-section-optional--checked[data-autocount="true"])
    > :global(.x-section-optional__children)
    > :global(h4:first-of-type::before),
.documentView
    :global(.x-section-optional--checked[data-autocount="true"])
    > :global(.x-section-optional__children)
    > :global(h5:first-of-type::before),
.documentView
    :global(.x-section-optional--checked[data-autocount="true"])
    > :global(.x-section-optional__children)
    > :global(h6:first-of-type::before) {
    content: counters(dibcounter, ".") ".";
    margin-right: 0.5rem;
    visibility: visible;
    width: auto;
}

.documentView
    :global(.x-section-optional:not(.x-section-optional--checked))
    :global(.x-section-optional__children)
    :global(h1:first-of-type::before),
.documentView
    :global(.x-section-optional:not(.x-section-optional--checked))
    :global(.x-section-optional__children)
    :global(h2:first-of-type::before),
.documentView
    :global(.x-section-optional:not(.x-section-optional--checked))
    :global(.x-section-optional__children)
    :global(h3:first-of-type::before),
.documentView
    :global(.x-section-optional:not(.x-section-optional--checked))
    :global(.x-section-optional__children)
    :global(h4:first-of-type::before),
.documentView
    :global(.x-section-optional:not(.x-section-optional--checked))
    :global(.x-section-optional__children)
    :global(h5:first-of-type::before),
.documentView
    :global(.x-section-optional:not(.x-section-optional--checked))
    :global(.x-section-optional__children)
    :global(h6:first-of-type::before) {
    display: none;
}

/* ── Ordered list counters ── */

.documentView
    :is(
        ol:not([type]) > li:not([class^="x-alternative"]),
        ol:not([style*="list-style-type"]) > li:not([class^="x-alternative"])
    ) {
    counter-increment: docgen-counter;
    display: flex;
}

.documentView
    :is(
        ol:not([type]) > li::before,
        ol:not([style*="list-style-type"]) > li::before
    ) {
    content: counter(docgen-counter) ".";
    margin-right: 0.5rem;
}

.documentView ol > li:global(.x-alternative)::before {
    display: none;
}

/* ── Optional items ── */

.documentView ol > li:global(.x-optional) {
    padding-left: 0.5rem;
}

.documentView ol > li:global(.x-optional) ~ li:global(.x-optional) {
    margin-top: 0.5rem;
}

.documentView ol > li:global(.x-optional) label {
    order: -1;
    position: relative;
}

.documentView ol > li:global(.x-optional) :global(.x-optional__children) {
    padding-left: 0.5rem;
}

.documentView :global(.x-section-optional),
.documentView :global(.x-optional) {
    opacity: 0.5;
    padding-left: 1.5rem;
    position: relative;
}

.documentView :global(.x-section-optional) > input,
.documentView :global(.x-optional) > input {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    position: absolute;
}

.documentView :global(.x-section-optional) > label,
.documentView :global(.x-optional) > label {
    height: 1.25rem;
    width: 1.25rem;
    min-width: 1.25rem;
    border: 2px solid hsl(197, 87%, 18%);
    border-radius: 0.25rem;
    display: inline-block;
    left: 0;
    position: absolute;
    top: 0;
    cursor: pointer;
}

.documentView :global(.x-section-optional) > h2,
.documentView :global(.x-optional) > h2 {
    display: inline-block;
    margin-top: -1rem;
    margin-bottom: 1rem;
}

.documentView :global(.x-section-optional--checked),
.documentView :global(.x-optional--checked) {
    opacity: 1;
}

.documentView :global(.x-section-optional--checked) > label,
.documentView :global(.x-optional--checked) > label {
    background-color: hsl(197, 87%, 18%);
    background-image: url(data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2040%2040%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20style%3D%22width%3A100%25%3Bheight%3A100%25%3B%22%3E%3Cpolyline%20points%3D%229.1%2C22.3%2015.7%2C28.8%2031.4%2C13%22%20stroke-dasharray%3D%2232.5%2C%2032.5%22%20stroke-dashoffset%3D%220%22%20stroke-width%3D%224%22%20style%3D%22stroke-dashoffset%3A%200%3Bfill%3Anone%3Bheight%3A2rem%3Bwidth%3A2rem%3Bstroke%3Argb%28255%2C255%2C255%29%3B%22%20%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E);
}

/* ── Focus indicators ── */

.documentView :global(.view-conditional--focused),
.documentView :global(.x-optional--focused),
.documentView :global(.x-alternatives.x-alternatives--focused),
.documentView :global(.x-alternatives-inline.x-alternatives--focused),
.documentView :global(.x-section-optional--focused) {
    border-radius: 0.5rem;
    box-shadow: 0px 0px 1px 1px hsla(20, 80%, 58%, 1);
}

/* ── Alternatives v2: main component ── */

.documentView :global(.alt2-alternatives) {
    margin: 1.5rem 0;
}

/* ── Alternatives v2: chip tray ── */

.documentView :global(.alt2-chips) {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;
    padding-left: 3px;
    align-items: center;
}

.documentView :global(.alt2-chip) {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 12px 5px 10px;
    font-size: 12.5px;
    font-weight: 400;
    color: #4a5568;
    background: #fff;
    border: 1px solid #d8dde6;
    border-radius: 100px;
    cursor: pointer;
    transition: all 0.15s ease;
    user-select: none;
    outline: none;
    white-space: nowrap;
    font-family: inherit;
}

.documentView :global(.alt2-chip):hover {
    border-color: #012b3c;
    color: #012b3c;
    background: #f0f4f8;
    box-shadow: 0 1px 4px rgba(1, 43, 60, 0.1);
}

.documentView :global(.alt2-chip):focus-visible {
    border-color: #012b3c;
    box-shadow: 0 0 0 2px rgba(1, 43, 60, 0.2);
}

.documentView :global(.alt2-chip--active) {
    border-color: #012b3c;
    font-weight: 600;
    cursor: default;
}

.documentView :global(.alt2-chip--active):hover {
    background: #fff;
    border-color: #012b3c;
    color: #4a5568;
    box-shadow: none;
}

.documentView :global(.alt2-chip__title) {
    line-height: 1;
}

/* ── Alternatives v2: selected content area ── */

.documentView :global(.alt2-selected) {
    position: relative;
    padding: 14px 16px;
    border-left: 3px solid #012b3c;
    background: linear-gradient(135deg, #f6f8fa 0%, #f1f4f7 100%);
    border-radius: 0 4px 4px 0;
    transition: background 0.2s ease;
}

.documentView :global(.alt2-selected__content) p:first-child {
    margin-top: 0;
}

.documentView :global(.alt2-selected__content) p:last-child {
    margin-bottom: 0;
}

.documentView :global(.alt2-alternatives--focused) :global(.alt2-selected) {
    border-left-color: hsla(20, 80%, 58%, 1);
}

/* ── Alternatives v2: expand toggle ── */

.documentView :global(.alt2-chips__expand-toggle) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid #d8dde6;
    background: #fff;
    color: #7a8599;
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;
    outline: none;
    margin-left: auto;
}

.documentView :global(.alt2-chips__expand-toggle):hover {
    border-color: #012b3c;
    color: #012b3c;
    background: #f0f4f8;
}

.documentView :global(.alt2-chips__expand-toggle):focus-visible {
    border-color: #012b3c;
    box-shadow: 0 0 0 2px rgba(1, 43, 60, 0.2);
}

/* ── Alternatives v2: expanded mode ── */

.documentView :global(.alt2-expanded-stack) {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.documentView :global(.alt2-expanded__item) {
    position: relative;
    padding: 14px 16px;
    border-left: 3px solid #012b3c;
    background: linear-gradient(135deg, #f6f8fa 0%, #f1f4f7 100%);
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    outline: none;
    transition:
        opacity 0.25s ease,
        border-color 0.25s ease;
}

.documentView :global(.alt2-expanded__item):focus-visible {
    outline: 2px solid #4a90b8;
    outline-offset: 2px;
}

.documentView :global(.alt2-expanded__item-title) {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #012b3c;
    background: rgba(1, 43, 60, 0.08);
    padding: 2px 8px;
    border-radius: 3px;
    margin-bottom: 8px;
}

.documentView :global(.alt2-expanded__item-content) p {
    margin: 12px 0;
}

.documentView :global(.alt2-expanded__item-content) p:first-child {
    margin-top: 0;
}

.documentView :global(.alt2-expanded__item-content) p:last-child {
    margin-bottom: 0;
}

.documentView :global(.alt2-expanded__item--active) {
    opacity: 1;
    cursor: default;
}

.documentView
    :global(.alt2-expanded__item):not(:global(.alt2-expanded__item--active)) {
    opacity: 0.4;
    border-left-color: #a0aab8;
}

.documentView
    :global(.alt2-expanded__item):not(
        :global(.alt2-expanded__item--active)
    ):hover {
    opacity: 0.65;
    border-left-color: #012b3c;
}

.documentView
    :global(.alt2-expanded__item):not(:global(.alt2-expanded__item--active))
    :global(.alt2-expanded__item-content) {
    pointer-events: none;
}

.documentView
    :global(.alt2-expanded__item):not(:global(.alt2-expanded__item--active))
    :global(.alt2-expanded__item-title) {
    color: #6b7a8d;
    background: rgba(1, 43, 60, 0.05);
}

/* ── Alternatives v2: mode switching ── */

.documentView :global(.alt2-alternatives) :global(.alt2-expanded-stack) {
    display: none;
}

.documentView :global(.alt2-alternatives--expanded) :global(.alt2-selected) {
    display: none !important;
}

.documentView
    :global(.alt2-alternatives--expanded)
    :global(.alt2-expanded-stack) {
    display: flex !important;
}

/* ── Comments ── */

.documentView :global(.x-comment) {
    background-color: rgba(201, 209, 231, 0.17);
    border-radius: 0.5rem;
    padding: 1.5rem;
    margin: 1rem 0;
}

.documentView :global(.x-comment) :global(.x-comment__body) p {
    margin: 0 0 1rem;
}

/* ── Tables ── */

.documentView table {
    border: 1px solid var(--mantine-color-gray-6);
    border-collapse: collapse;
    border-spacing: 0;
    margin: var(--mantine-spacing-xl) 0;
    width: 100%;
}

.documentView thead {
    background-color: hsl(195, 20%, 96%);
    border: 1px solid var(--mantine-color-gray-6);
}

.documentView thead th {
    border: 1px solid var(--mantine-color-gray-6);
    padding: 0.5rem 1rem;
}

.documentView tbody td {
    padding: 0.5rem 1rem;
    border: 1px solid var(--mantine-color-gray-6);
}

.documentView tbody td:empty {
    padding: 1.25rem 1rem;
}

.documentView table:global(.tbNoBorder) {
    border: none;
}

.documentView table:global(.tbNoBorder) thead {
    border: none;
}

.documentView table:global(.tbNoBorder) thead td {
    border: none;
}

.documentView table:global(.tbNoBorder) tbody td {
    border: none;
}

/* ── Alternatives v2: popover (portalled to body, outside document scope) ── */

:global(.alt2-popover) {
    padding: 0;
    border: 1px solid #d6dce6;
    border-radius: 6px;
    max-width: 650px;
}

:global(.alt2-popover__header) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px 10px;
    border-bottom: 1px solid #eef0f4;
}

:global(.alt2-popover__title) {
    font-size: 13px;
    font-weight: 700;
    color: #012b3c;
    letter-spacing: 0.01em;
}

:global(.alt2-popover__badge) {
    font-size: 10.5px;
    font-weight: 400;
    color: #8a95a5;
    background: #f3f5f8;
    padding: 2px 8px;
    border-radius: 10px;
}

:global(.alt2-popover__body) {
    position: relative;
    padding: 14px 16px;
    font-size: 13.5px;
    line-height: 1.5;
    color: #4a5568;
    max-height: 200px;
    overflow-y: auto;
}

:global(.alt2-popover__body-inner) {
    pointer-events: none;
}

:global(.alt2-popover__body) p {
    margin: 8px 0;
}

:global(.alt2-popover__body) p:first-child {
    margin-top: 0;
}

:global(.alt2-popover__body) p:last-child {
    margin-bottom: 0;
}

:global(.alt2-popover__body) :global(.x-comment) {
    background: rgba(201, 209, 231, 0.12);
    border-radius: 4px;
    padding: 10px 12px;
    margin: 8px 0 0;
    font-size: 12.5px;
    color: #5e6b7a;
}

:global(.alt2-popover__body) table {
    width: 100%;
    border-collapse: collapse;
    margin: 8px 0;
    font-size: 12.5px;
}

:global(.alt2-popover__body) th,
:global(.alt2-popover__body) td {
    padding: 6px 10px;
    border: 1px solid #dde1e8;
    text-align: left;
}

:global(.alt2-popover__body) thead td {
    background: #f4f6f8;
    font-weight: 700;
}

/** Legacy link styling */

/* Inline link parity (LEGACY). Unlayered to beat the unlayered
   `.navLink` rule in components/contentLink.module.css. Hardcoded blue
   per TASK_FINALIZED (not factored with #1). */
.documentView :global(a)[href]:not([href="#"]) {
    color: rgb(43, 102, 199);
    text-decoration: none;
}

.documentView :global(a)[href]:not([href="#"]):hover {
    text-decoration: underline;
}
